import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "../APIClient";
import { AvailableDateResponseDto } from "../generated/generatedTypes";
import { getApiErrorMessage } from "../getApiErrorMessage";

export const useGetAvailableDates = () => {
  return useQuery({
    queryKey: ["available-dates"],
    queryFn: async (): Promise<AvailableDateResponseDto[]> => {
      const response = await apiFetch("api/questions/available-dates");
      if (!response.ok) {
        throw new Error(await getApiErrorMessage(response));
      }
      return response.json();
    },
  });
};
